import { useEffect, useState } from "react";

import config from "Constants/api_config";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import getAccessToken from "src/organization/pages/project/environment/metrics/api/getAccessToken";
import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";

import { ActivityFilterType, ActivityWorkerState } from "./type";
import { groupActivities } from "./util";

let sharedWorker: Worker | undefined = undefined;

type UseActivityWorkerProps = {
  timeFrame?: TimeFrameType;
  activityConfig?: ActivityFilterType[];
  isDeployment: boolean;
};

const defaultConfigData = {
  group: [],
  activities: []
};

const defaultConfig: ActivityFilterType[] = ["autoscale", "deployment"];

const useActivityWorker = (props?: UseActivityWorkerProps) => {
  const {
    timeFrame,
    activityConfig = defaultConfig,
    isDeployment = true
  } = props || {};
  const [configData, setConfigData] = useState<ActivityWorkerState>({
    group: [],
    activities: []
  });

  if (!sharedWorker) {
    sharedWorker = new Worker(new URL("./activityWorker.ts", import.meta.url), {
      type: "module"
    });
  }

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const { payload } = event.data;
      const activities = payload.activities;
      const group = groupActivities(activityConfig, activities);
      setConfigData({ activities, group });
    };

    sharedWorker?.addEventListener("message", handleMessage);

    return () => {
      sharedWorker?.removeEventListener("message", handleMessage);
    };
  }, [activityConfig]);

  const environment = useSelectorWithUrlParams(environmentSelector);
  const activityLink = environment?.getLinks()?.["#activities"].href;

  useEffect(() => {
    if (!isDeployment || !activityLink) return;
    (async () => {
      const token = await getAccessToken();
      const api = config.api_url;
      sharedWorker?.postMessage({
        type: "fetch",
        payload: { timeFrame, token, api, activityLink }
      });
    })();
  }, [timeFrame?.hash, timeFrame, activityLink, isDeployment]);
  return isDeployment ? configData : defaultConfigData;
};

export default useActivityWorker;
